require.config({
    baseUrl: 'base/scripts',
    paths: {
        'dragula'           : 'vendor/dragula',
        'dropkick'          : 'vendor/dropkick',
        'hammer'            : 'vendor/hammer-2.0.8.min',
        'jquery'            : 'vendor/jquery-2.1.4/jquery',
        'knockout'          : 'vendor/knockout-3.4.2',
        'knockout-mapping'  : 'vendor/knockout-mapping-2.4.1/knockout.mapping',
        'nouislider'        : 'vendor/nouislider-7.0.10/jquery.nouislider',

        'requirejs'         : 'vendor/requirejs/require',

        'comment-tool'      : 'ui-components/commenttool',
        'pagination'        : 'ui-components/pagination',

        'course-componentVM'    : 'view-models/course-component',
        'component-glossary'    : 'view-models/course-components/glossary',
        'component-footer-timeline': 'view-models/course-components/footer-timeline',

        'page-component'        : 'view-models/page-component', // TODO: all page component should be moved under this. Also answer popup from ext
        'modular-navigation'    : 'view-models/page-components/modular-navigation',
        'leaderboard'           : 'view-models/page-components/leaderboard',

        'component-accordion'   : 'view-models/page-components/accordion',
        'component-answer-popup': 'view-models/page-components/answer-popup',
        'component-hotspots'    : 'view-models/page-components/hotspots',
        'component-diploma'     : 'view-models/page-components/diploma',
        'component-extra-info'  : 'view-models/page-components/extra-info',
        'component-flip-cards'  : 'view-models/page-components/flip-cards',
        'component-media'       : 'view-models/page-components/media',
        'component-slide-show'  : 'view-models/page-components/slide-show',
        'component-statistics'  : 'view-models/page-components/statistics',
        'component-super-button': 'view-models/page-components/super-button',
        'component-tabs'        : 'view-models/page-components/tabs',

        'layout'            : 'view-models/layout',
        'course'            : 'view-models/course',
        'entity'            : 'view-models/entity',
        'trainingVM'        : 'view-models/training',
        'navigationVM'      : 'view-models/navigation',
        'user'              : 'view-models/user',
        'view-model'        : 'view-models/view-model',
        'quiz-game'         : 'view-models/quiz-game',

        'TweenMax'          : 'vendor/TweenMax',
        'TimelineMax'       : 'vendor/gsap-1.18.2.1/TimelineMax',
        'TweenLite'         : 'vendor/gsap-1.18.2.1/TweenLite',
        'DrawSVGPlugin'     : 'vendor/gsap-1.18.2.1/plugins/DrawSVGPlugin',
        'MorphSVGPlugin'    : 'vendor/gsap-1.18.2.1/plugins/MorphSVGPlugin',

        'qTip'              : 'vendor/qtip2-2.2.1/jquery.qtip',

        'swiper'            : 'vendor/swiper-3.4.0.min',
        'isotope'           : 'vendor/isotope-3.0.1',

        // Polyfill ------------------------------------------
        'polyfill': 'modules/polyfill/polyfill',
        'polyfill.io': 'modules/polyfill/polyfill.io',

        // Extensions ------------------------------------------
        'extension': 'modules/extension/extension',
        'pubsub': 'modules/extension/pubsub',

        // Modules ES6 -----------------------------------------
        'svg': 'modules/svg/svg.amd',
        'snap-svg': 'modules/svg/vendor/snap.svg-0.5.1',

        'snap-svg-plugin'   : 'modules/svg/snap-svg-plugin',

        'svg--get-attributes': 'modules/svg/svg--get-attributes.amd',
        'svg--update-weight': 'modules/svg/svg--update-weight.amd',

        'validation': 'modules/validation/validation.amd',
        'validation--counter-boxes': 'modules/validation/validation--counter-boxes.amd',
        'validation--counter-choices': 'modules/validation/validation--counter-choices.amd',
        'validation--counter-emails': 'modules/validation/validation--counter-emails.amd',
        'validation--counter-questions': 'modules/validation/validation--counter-questions.amd',
        'validation--counter-ratings': 'modules/validation/validation--counter-ratings.amd',
        'validation--match-pair': 'modules/validation/validation--match-pair.amd',
        'validation--sort-to-groups': 'modules/validation/validation--sort-to-groups.amd',

        // Helpers ---------------------------------------------
        'helpers': 'core/helpers/_helpers',

        'helper-component-setStructure': 'helpers/component--set-structure.amd',
        'helper-component-getContentArray': 'helpers/component--get-content-array.amd',
        'helper-component-getContent': 'helpers/component--get-content.amd',
        'helper-component-parseContent': 'helpers/component--parse-content.amd',
        'helper-component-parseProp': 'helpers/component--parse-prop.amd',

        'helper-content-getEntity': 'helpers/content--get-entity.amd',
        'helper-content-getQuizGame': 'helpers/content--get-quiz-game.amd',
        'helper-content-getTrainingMap': 'helpers/content--get-training-map.amd',

        'helper-state-getComponent': 'helpers/state--get-component.amd',
        'helper-state-getProps': 'helpers/state--get-props.amd',

        'helper-url-getParam': 'helpers/url--get-param.amd',
        'helper-url-parseModified': 'helpers/url--parse-modified.amd',

        // 'helperContent': 'core/helpers/content/_content',
        'helperContent-cloneEntity': 'core/helpers/content/clone-entity',
        'helperContent-cloneInitEntity': 'core/helpers/content/clone-init-entity',
        // 'helperContent-getEntity': 'core/helpers/content/get-entity',
        'helperContent-getTaskEntities': 'core/helpers/content/get-task-entities',
        // 'helperContent-getQuizGame': 'core/helpers/content/get-quiz-game',
        'helperContent-getQuizMap': 'core/helpers/content/get-quiz-map',
        'helperContent-getSectionEntities': 'core/helpers/content/get-section-entities',
        // 'helperContent-getTrainingMapping': 'core/helpers/content/get-training-map',
        'helperContent-convertComponents': 'core/helpers/content/convert-components',
        'helperContent-componentObject': 'core/helpers/content/component-object',
        'helperContent-customText': 'core/helpers/content/custom-text',

        // 'helperEntity': 'core/helpers/entity/_entity',
        // 'helperEntity-isContentPage': 'core/helpers/entity/is-content-page',
        // 'helperEntity-isInPageRange': 'core/helpers/entity/is-in-page-range',
        // 'helperEntity-isParentQuizTaskPage': 'core/helpers/entity/is-parent-quiz-task-page',
        // 'helperEntity-isQuizGamePage': 'core/helpers/entity/is-quiz-game-page',
        // 'helperEntity-isQuizPage': 'core/helpers/entity/is-quiz-page',
        'helperEntity-isQuizTaskPage': 'core/helpers/entity/is-quiz-task-page',
        // 'helperEntity-isTaskInScore': 'core/helpers/entity/is-task-in-score',
        // 'helperEntity-isTaskPage': 'core/helpers/entity/is-task-page',

        'helper-entity-isContentPage': 'helpers/entity--is-content-page.amd',
        'helper-entity-isInPageRange': 'helpers/entity--is-in-page-range.amd',
        'helper-entity-isParentQuizTaskPage': 'helpers/entity--is-parent-quiz-task-page.amd',
        'helper-entity-isQuizGamePage': 'helpers/entity--is-quiz-game-page.amd',
        'helper-entity-isQuizPage': 'helpers/entity--is-quiz-page.amd',
        'helper-entity-isQuizTaskPage': 'helpers/entity--is-quiz-task-page.amd',
        'helper-entity-isTaskInScore': 'helpers/entity--is-task-in-score.amd',
        'helper-entity-isTaskPage': 'helpers/entity--is-task-page.amd',

        'helperLayout': 'core/helpers/layout/_layout',
        'helperLayout-appendContent': 'core/helpers/layout/append-content',
        'helperLayout-prependContent': 'core/helpers/layout/prepend-content',
        'helperLayout-createNode': 'core/helpers/layout/create-node',
        'helperLayout-isMissing': 'core/helpers/layout/is-missing',
        'helperLayout-nodeStyle': 'core/helpers/layout/node-style',
        'helperLayout-scrollTop': 'core/helpers/layout/scroll-top',

        // 'helperMisc': 'core/helpers/misc/_misc',
        // 'helperMisc-cloneObject': 'core/helpers/misc/clone-object',
        'helper-misc-cloneObject': 'helpers/misc--clone-object.amd',
        'helper-misc-msToCMI': 'helpers/misc--ms-to-cmi.amd',
        'helper-misc-msToISO': 'helpers/misc--cs-to-iso.amd',
        // 'helperMisc-formatTime': 'core/helpers/misc/format-time',
        'helperMisc-replaceTextholder': 'core/helpers/misc/replace-textholder',


        'helperNavigation': 'core/helpers/navigation/_navigation',
        'helperNavigation-getSectionNId': 'core/helpers/navigation/get-section-n-id',
        'helperNavigation-getSectionNFromEndId': 'core/helpers/navigation/get-section-n-from-end-id',
        'helperNavigation-isLevel1': 'core/helpers/navigation/is-level-1',
        'helperNavigation-isLevel1NoChildren': 'core/helpers/navigation/is-level-1-no-children',
        'helperNavigation-isSection1stPage': 'core/helpers/navigation/is-section-1st-page',
        'helperNavigation-isSectionLastPage': 'core/helpers/navigation/is-section-last-page',

        'helperUser': 'core/helpers/user/_user',
        'helperUser-getAnswer': 'core/helpers/user/get-answer',
        'helperUser-getMultipleChoiceSelectedOptionsCount': 'core/helpers/user/get-multiple-choice-selected-options-count',
        'helperUser-customPoints': 'core/helpers/user/custom-points',
        'helperUser-customStorage': 'core/helpers/user/custom-storage',

        // Utils -----------------------------------------------
        'utils': 'core/utils/_utils',

        // Data Context ----------------------------------------
        'redux': 'modules/store/vendor/redux.min',
        'store': 'modules/store/store.amd',

        'store-helper-get-props': 'modules/store/helpers/helper-get-props.amd',
        'store-helper-get-content': 'modules/store/helpers/helper-get-content.amd',

        'reducer-training': 'modules/store/reducers/training.amd',
        'reducer-entity': 'modules/store/reducers/entity.amd',
        'reducer-user': 'modules/store/reducers/user.amd',

        'middleware-set-training': 'modules/store/middlewares/set-training.amd',
        'middleware-set-entity': 'modules/store/middlewares/set-entity.amd',
        'middleware-set-user': 'modules/store/middlewares/set-user.amd',

        // 'reducer-navigation': 'modules/store/reducers/navigation.amd',

        'data-context': 'modules/data-context/data-context',

        'fetch-local': 'modules/data-context/fetch-local',
        'fetch-offline': 'modules/data-context/fetch-offline',
        'fetch-scorm': 'modules/data-context/fetch-scorm',
        'fetch-training': 'modules/data-context/fetch-training',
        'get-learning': 'modules/data-context/get-learning',
        'live-reload': 'modules/data-context/live-reload',
        'load-modules': 'modules/data-context/load-modules',

        // Scorm Package ---------------------------------------
        'scormAPI': 'modules/scorm/scorm-api',
        'scormPackage': 'modules/scorm/scorm-package',

        // Tasks -----------------------------------------------
        'task': 'view-models/task',
        'task-match-pair': 'view-models/tasks/match-pair',
        'task-open-question': 'view-models/tasks/open-question',
        'task-sort-to-groups': 'view-models/tasks/sort-to-groups',
        'task-yes-no-question': 'view-models/tasks/yes-no-question',
        'task-evaluate': 'view-models/tasks/evaluate',

        // Modules ---------------------------------------------
        'dialog': 'modules/dialog/dialog/dialog',
        'modal': 'modules/dialog/modal/modal',
        'dialog-manager': 'modules/dialog/dialog-manager',

        'contentLayout': 'modules/layout/content-layout',
        'contentPreload': 'modules/layout/content-preload',
        'contentUtils': 'modules/layout/content-utils',
        'layout-mobile': 'modules/layout/layout-mobile',
        'layout-header': 'modules/layout/layout-header',

        // media
        'media': 'modules/media/media',
        //'vimeo': ['//player.vimeo.com/api/player'],
        //'vimeo': 'modules/media/vendor/vimeo-player-2.6.3.min',
        'plyr' : 'modules/media/vendor/plyr.polyfilled.min',

        // graph
        'graph': 'modules/graph/graph',
        'c3': 'modules/graph/vendor/c3-0.4.11.min',
        'd3': 'modules/graph/vendor/d3-3.5.17.min',

        'gsap': 'modules/gsap/gsap',

        // navigation
        'navigation': 'modules/navigation/navigation',
        'navigation-transition': 'modules/navigation/transition',
        'navigation-validation': 'modules/navigation/validation',

        'training': 'modules/training/training',
        'notification': 'modules/training/notification',
        'user-answers': 'modules/user-answers/user-answers',
        'get-answer-prop': 'modules/user-answers/get-answer-prop.amd',
        'get-tasks-answers': 'modules/user-answers/get-tasks-answers.amd',

        'feedback': 'modules/feedback/feedback',
        'tooltip': 'modules/tooltip/tooltip',

        'config': '../../config',
        'custom': '../../custom/custom-js',
        'offlineData': '../../custom/content',
        'custom-lang': '../../custom/custom-lang',
        'compiled/custom-templates': 'excluded/custom-templates'
    },
    map: {
        '*': {
            'dataContext': 'data-context',   // deprecated

            '../../../helpers/component--set-structure.es': 'helper-component-setStructure',

            'component--get-content-array.es': 'helper-component-getContentArray',
            'component--get-content.es': 'helper-component-getContent',
            'component--parse-content.es': 'helper-component-parseContent',
            'component--parse-prop.es': 'helper-component-parseProp',

            'content--get-entity.es': 'helper-content-getEntity',
            'content--get-training-map.es': 'helper-content-getTrainingMap',
            'content--get-quiz-game.es': 'helper-content-getQuizGame',

            'state--get-component.es': 'helper-state-getComponent',
            'state--get-props.es': 'helper-state-getProps',

            'url--get-param.es': 'helper-url-getParam',
            'url--parse-modified.es': 'helper-url-parseModified',

            'entity--is-content-page.es': 'helper-entity-isContentPage',
            'entity--is-in-page-range.es': 'helper-entity-isInPageRange',
            'entity--is-parent-quiz-task-page.es': 'helper-entity-isParentQuizTaskPage',
            'entity--is-quiz-game-page.es': 'helper-entity-isQuizGamePage',
            'entity--is-quiz-page.es': 'helper-entity-isQuizPage',
            'entity--is-quiz-task-page.es': 'helper-entity-isQuizTaskPage',
            'entity--is-task-in-score.es': 'helper-entity-isTaskInScore',
            'entity--is-task-page.es': 'helper-entity-isTaskPage',

            // 'helper-misc-cloneObject': 'helpers/misc--clone-object.amd',
            'misc--clone-object.es': 'helper-misc-cloneObject',
            'misc--ms-to-cmi.es': 'helper-misc-msToCMI',
            'misc--cs-to-iso.es': 'helper-misc-msToISO',


            './modules/store/store.es': 'store',

            'vendor/snap.svg-0.5.1': 'snap-svg',

            'svg--get-attributes.es': 'svg--get-attributes',
            'svg--update-weight.es': 'svg--update-weight',

            'validation--counter-boxes.es': 'validation--counter-boxes',
            'validation--counter-choices.es': 'validation--counter-choices',
            'validation--counter-emails.es': 'validation--counter-emails',
            'validation--counter-questions.es': 'validation--counter-questions',
            'validation--counter-ratings.es': 'validation--counter-ratings',
            'validation--match-pair.es': 'validation--match-pair',
            'validation--sort-to-groups.es': 'validation--sort-to-groups',
        }
    },
    shim: {
        'knockout-mapping': {
            deps: [
                'knockout'
            ]
        },
        'c3': {
            deps: ['d3']
        },
        'helperContent-componentObject' : {
            deps: ['knockout-mapping']
        },
        'helperLayout-setSvgTexts': {
            deps: [
                'helperContent-componentObject'
            ]
        },
        'leaderboard' : {
            deps: [
                'helperContent-componentObject'
            ]
        },
        'modal': {
            deps: [
                'dialog'
            ]
        },
        'compiled/custom-templates': {
            deps: ['custom']
        },
        'custom': {
            deps: []
        },
        'dropkick': {
            deps: [
                'jquery'
            ]
        },
        'nouislider': {
            deps: ['jquery']
        },
        'layout': {
            deps: []
        },
        'course': {
            deps: []
        },

        // 'svg': {
        //     deps: [
        //         'snap-svg',
        //         'snap-svg-plugin'
        //     ]
        // },

        'swiper': {
            deps: [
                'jquery'
            ]
        },
        'TweenMax': {
            exports: 'TweenMax',
            deps: [
                'TweenLite'
            ]
        },
        'TimelineMax': {
            exports: 'TimelineMax',
            deps: [
                'TweenMax'
            ]
        }
    },
    waitSeconds: 0
});

require(['extension', 'jquery', 'config', 'data-context'], function(extension, $, config, DataContext) {
    var dataContext = new DataContext(config);

    // move to bindings file?
    if (Modernizr.localstorage || Modernizr.sessionstorage) {
        $(document).keydown(function(e){

            if (Modernizr.localstorage && e.shiftKey && e.ctrlKey && e.altKey && (e.keyCode === 56 || e.which === 56 || e.keyCode === 106 || e.which === 106 ) ) { // Shift + Ctrl + Alt + *
                if(window.confirm('Clear the entire storage area?')) {
                    window.localStorage.clear();
                    window.location.reload(true);
                }
            } else if (Modernizr.localstorage && e.shiftKey && e.ctrlKey && e.altKey && (e.keyCode === 67 || e.which === 67) ){ // Shift + Ctrl + Alt + C
                if ( window.confirm('Remove the value for this course and current user?') ) {
                    window.localStorage.removeItem(dataContext.trainingID);
                    window.localStorage.removeItem(dataContext.trainingID + '-' + dataContext.userID);
                    window.location.reload(true);
                }
            }

            if (Modernizr.sessionstorage && e.shiftKey && e.ctrlKey && e.altKey && (e.keyCode === 68 || e.which === 68) ){ // Shift + Ctrl + Alt + D
                window.sessionStorage.setItem('debugMode', window.sessionStorage.getItem('debugMode') !== 'true' );
                window.location.reload(true);
            }

        });
    }

});

require(['helpers', 'knockout'], function(helpers, ko) {

    if(!window.ghp){
        window.ghp = {};
    }

    if(!window.ghp.helpers) {
        window.ghp.helpers = helpers;
    }

    if(!window.ghp.ko) {
        window.ghp.ko = ko;
    }
});

define("main", function(){});

